import Axios from "axios";
import {
  SET_EMPLOYEE_DAILY_ATTENDANCE_SHEET_REPORT,
  UNSET_EMPLOYEE_DAILY_ATTENDANCE_SHEET_REPORT,
} from "@/store/mutation-types";
import {
  getEmployeeDailyAttendanceSheetReport,
} from "@/store/api";

const state = {
  employeeDailyAttendanceSheetReport: [],
};

const getters = {
  getEmployeeDailyAttendanceSheetReport(state) {
    return state.employeeDailyAttendanceSheetReport;
  },
};

const mutations = {
  [SET_EMPLOYEE_DAILY_ATTENDANCE_SHEET_REPORT](state, data) {
    state.employeeDailyAttendanceSheetReport = data;
  },
  [UNSET_EMPLOYEE_DAILY_ATTENDANCE_SHEET_REPORT](state) {
    state.employeeDailyAttendanceSheetReport = [];
  },
};

const actions = {
  getEmployeeDailyAttendanceSheet({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getEmployeeDailyAttendanceSheetReport}`, { params: data })
        .then((response) => {
          commit(SET_EMPLOYEE_DAILY_ATTENDANCE_SHEET_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_EMPLOYEE_DAILY_ATTENDANCE_SHEET_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

